module.exports = __webpack_public_path__ + "img/48.ae88da3a.jpg";